<style scoped>

</style>
<template>
  <v-autocomplete
    v-bind="$attrs"
    :value="value"
    :items="select_teams"
    :item-text="(t) => (`${t.name}${t.del ? '(已废弃)' : ''}`)"
    item-value="id"
    :rules="$attrs.rules"
    :placeholder="calc_placeholder"
    v-on="$listeners"
  >
    <template v-slot:label> 
      <span><span
        v-show="$attrs.required"
        style="color:red"
      >*</span>{{ $attrs.label }}</span>
    </template>
  </v-autocomplete>
</template>
<script>
  import {mapGetters} from "vuex";

  export default {
    inheritAttrs: false,
    props: {
      value: {
        type: [Number, String]
      },
      allowBlank: {
        type: Boolean,
        default: false
      },
      disabledArr: {
        type:Array,
        default: () => []
      },
      showDel: {
        type:Boolean,
        default: () => true
      },
      teams: {
        type: Array,
        default: () => []
      },
      teams_hash: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        //
      }
    },
    computed: {
      // ...mapGetters('async', {
      //   teams: 'root_teams',
      //   teams_hash: 'teams_hash',
      // }),
      select_teams() {
        let arr = this.teams
        if (this.allowBlank) {
          arr = [{id: 0, name: '无'}].concat(this.teams)
        }
        return arr.filter(item => {
          if (this.showDel) {
            return true
          } else {
            return !item.del
          }
        }).filter(item => !this.disabledArr.includes(item.id));
      },
      calc_placeholder() {
        const team_id = this.value;
        if (team_id > 0) {
          console.log(team_id)
          console.log(this.teams_hash)
          console.log(this.teams_hash[team_id])
          const team = this.teams_hash[team_id];
          return team ? team.name : '未获取到团队信息';
        }
        return this.placeholder;
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>
